var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-navbar"},[_c('ul',{staticClass:"sub-menu"},_vm._l((_vm.linksObject),function(link,linkKey){return _c('router-link',{key:linkKey,attrs:{"to":link.src}},[_c('li',{class:{ 'nav-link-rnd-selected': _vm.$route.name === link.activatedByRoute }},[_vm._v("\n                "+_vm._s(link.name)+"\n            ")])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }